import { Types as AlchemistTypes } from "alchemist";
import { CommonNode } from "@foundation/rich-text-react-renderer";

import overrides from "~constants/securities";

export const createQuotePageHref = (ticker: string, exchange: string) => {
    const preferredExchange = exchange === "JT" ? "JP" : exchange;

    return `/quote/${ticker}:${preferredExchange}`;
};

export const getSecurityUrl = (node: CommonNode) => {
    const { data } = node as unknown as AlchemistTypes.Security;
    const parsekey = data?.security?.identifiers?.parsekey as unknown as any;
    let security = parsekey?.replace("Index", "Ind").split(" ");

    if (security) {
        security = `${security?.[0]}:${security?.[1]}`;
        security = overrides[security] ? overrides[security] : security;

        return `https://www.bloomberg.com/quote/${security}`;
    }

    const {
        destination: { web, bbg },
    } = (data?.link || {}) as AlchemistTypes.LinkData;

    if (web) return web;

    if (bbg) {
        const [ticker, exchange] = bbg
            .substring("bbg://securities/".length)
            .split(/:|%20/);
        return `https://www.bloomberg.com${createQuotePageHref(
            ticker,
            exchange
        )}`;
    }

    return "";
};
